angular.module("Main").controller("ChangePasswordController", ["$rootScope", "$scope", "$location", "$state", "$cookies", "$uibModal", "$uibModalInstance",
    "AuthenticationService", "BookingService", "SessionService", "DialogService",
    function ($rootScope, $scope, $location, $state, $cookies, $uibModal, $uibModalInstance, AuthenticationService, BookingService, SessionService, DialogService) {
        var vm = this;

        vm.dataForm = {};
        vm.newPassword = {};
        vm.forgot = {};
        vm.changePassword = true;
        vm.passwordSecretNew = 'password';
        // reset login status
        SessionService.clear("globals");

        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
            vm.registrierungZulassen = data.RegistrierungZulassen;
        });


        vm.passwordFieldToogle = function () {
            if (vm.passwordSecretNew === 'password') {
                vm.passwordSecretNew = 'text'
            } else {
                vm.passwordSecretNew = 'password';
            }
        };

       let changePassword = false;
        vm.saveChangedPassword = function (change) {
            vm.dataForm.firstname.$setTouched();
            vm.dataForm.lastname.$setTouched();
            vm.dataForm.email.$setTouched();
            vm.openFormForgotPassword = false;
            vm.changePassword = true;
            vm.openFormChangePassword = true;
            vm.errorText = null;
            vm.infoText = null;

            if (vm.dataForm.$valid) {
                if (!changePassword) {
                    changePassword = true;
                    vm.dataLoading = true;
                    BookingService.findUser(change.firstname, change.email).then(function () {
                        return AuthenticationService.checkPassword(change.email, change.password);
                    }).then(function (data) {
                        if (data !== null) {
                            AuthenticationService.changePassword(data.uid, change.changedPassword).then(function () {
                                changePassword = false;
                                vm.dataLoading = false;
                                vm.openFormForgotPassword = false;
                                vm.wrongLoginData = false;
                                vm.newPasswordSend = true;
                                vm.infoText = "LT_Password_erfolgreich_geändert";
                            }).catch(function () {
                                changePassword = false;
                                vm.dataLoading = false;
                                vm.errorHeader = "T_Fehler";
                                vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                            })
                        } else {
                            changePassword = false;
                            vm.dataLoading = false;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_PASSWORT_EMAIL_WRONG";
                        }
                    }).catch(function () {
                        changePassword = false;
                        vm.dataLoading = false;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_PASSWORT_EMAIL_WRONG";
                    })
                }
            }
        };

        vm.registerModal = function () {
            $uibModalInstance.close();
            DialogService.openRegisterDialog().catch(function (error) { })
        };

    }]);